import { FecImportLifecycleStatus } from '../enums/fecImportLifecycleStatus'
import type { FecImportItem } from '../query-api'

// Parsed and detected without failure; later lifecycle states (review, push, done) imply it.
const ANALYSIS_COMPLETE_STATUSES: ReadonlySet<FecImportLifecycleStatus> = new Set([
  FecImportLifecycleStatus.Done,
  FecImportLifecycleStatus.InReview,
  FecImportLifecycleStatus.PushFailed,
  FecImportLifecycleStatus.PushingToBilly,
])

export const isFecImportAnalysisComplete = (fecImport: Pick<FecImportItem, 'status'>): boolean =>
  ANALYSIS_COMPLETE_STATUSES.has(fecImport.status)
